import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export function useUpdatePlanejamentoOperacional() {
   return useMutation(async ({ id, body }: { id: string; body: any }) => {
      const response = await http.put(URL.PLANO_OPERACIONAL.ATUALIZAR_PLANEJAMENTO(id), body);
      return response;
  });
}

export function useUpdatePlanejamentoOperacionalOperacao() {
   return useMutation(async ({ id, body }: { id: string; body: any }) => {
      const response = await http.put(URL.PLANO_OPERACIONAL.CRIAR_PLANEJAMENTO_OPERACAO(id), body);
      return response;
  });
}

export function useUpdatePlanejamentoOperacionalSafra() {
   return useMutation(async ({ id, body }: { id: string; body: any }) => {
      const response = await http.post(URL.PLANO_OPERACIONAL.ATUALIZAR_SAFRA(id), body);
      return response;
  });
}
